const getters = {};

export default getters;



// WEBPACK FOOTER //
// ./scripts/store/getters.js